export const NAVIGATE_FORWARD = 'NAVIGATE_FORWARD'
export const NAVIGATE_BACKWARD = 'NAVIGATE_BACKWARD'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const GET_USER_DATA = 'GET_USER_DATA'
export const IS_UPDATE_USER_STORE = 'IS_UPDATE_USER_STORE'
